// Hide Shop Pay and PayPal buttons - Keep Apple Pay and Google Pay only
document.addEventListener('DOMContentLoaded', function() {
  // Function to hide unwanted payment buttons
  function hidePaymentButtons() {
    // Hide Shop Pay buttons
    const shopPayButtons = document.querySelectorAll(
      '[data-testid="ShopifyPay-button"], ' +
      '.shopify-payment-button__button[aria-label*="Shop Pay"], ' +
      '.shopify-payment-button__button[aria-label*="ShopPay"], ' +
      '.shopify-payment-button__button--unbranded'
    );

    shopPayButtons.forEach(button => {
      button.style.display = 'none';
    });

    // Hide PayPal buttons
    const paypalButtons = document.querySelectorAll(
      '[data-testid="PayPal-button"], ' +
      '.shopify-payment-button__button[aria-label*="PayPal"], ' +
      'button[aria-label*="PayPal"]'
    );

    paypalButtons.forEach(button => {
      button.style.display = 'none';
    });

    // Also check accelerated checkout
    const acceleratedCheckout = document.querySelector('shopify-accelerated-checkout');
    if (acceleratedCheckout) {
      const recommended = acceleratedCheckout.getAttribute('recommended');
      if (recommended?.includes('shop_pay') || recommended?.includes('paypal')) {
        acceleratedCheckout.setAttribute('recommended', '{}');
      }
    }
  }

  // Run immediately
  hidePaymentButtons();

  // Also run after a delay to catch dynamically loaded elements
  setTimeout(hidePaymentButtons, 1000);
  setTimeout(hidePaymentButtons, 2000);

  // Observer to hide payment buttons if they appear later
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        hidePaymentButtons();
      }
    });
  });

  // Start observing
  const checkoutContainer = document.querySelector('.accelerated-checkout-block, .product-form-buttons, .cart-drawer');
  if (checkoutContainer) {
    observer.observe(checkoutContainer, {
      childList: true,
      subtree: true
    });
  }
});